import Vue from 'vue'
import VueRouter from 'vue-router'
// import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import router from './router/router'
import store from './vuex/store'
import axios from 'axios'
import _ from 'lodash'
import routerInit from './router/router-actions'
// import axiosInterceptors from './init/axios-interceptors';
// import initEditorQuill from './init/editor-quill'
// import has from './directives/has'
// import focus from './directives/focus'

// css
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/swiper.scss'
import 'vue-resize/dist/vue-resize.css'
// import 'cropperjs/dist/cropper.css';
import './scss/index.scss';

// Add additional themes.
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";

import VueResize from 'vue-resize'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/radar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'

import 'jzl-web-components/lib/jwcomps/jwcomps.css';

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueTippy, { TippyComponent } from "vue-tippy";
import VModal from 'vue-js-modal';
import VueGridLayout from 'vue-grid-layout';
import JzlWebApi from "jzl-web-api"
import JzlWebComponents from "jzl-web-components"

// import dyncComp from './components/dync-comp';

// components
Vue.component('v-chart',                    ECharts);
Vue.component('GridLayout',                 VueGridLayout.GridLayout);
Vue.component('GridItem',                   VueGridLayout.GridItem);
Vue.component("PerfectScrollbar",           VuePerfectScrollbar);
// Vue.component('dync-comp',                  dyncComp);
Vue.component("tippy",                      TippyComponent);

Vue.use(VueRouter);
Vue.use(ElementUI);
// Vue.use(VueResource)
Vue.use(VueResize)
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(VModal, { dynamicDefaults: { draggable: true, resizable: true } });
Vue.use(VueTippy);
Vue.use(JzlWebApi);
Vue.use(JzlWebComponents);

// 注册特有的axios全局拦截器
if(process.env.NODE_ENV === 'production') {
    JzlWebComponents.AxiosInterceptor(axios, store);
} else {
    JzlWebComponents.AxiosInterceptor(axios, store, function (pid) {
        router.replace({
            name: 'login',
            query: {
                pid: pid
            },
            replace: true
        });
    });
}

// 图标库单独特殊处理
JzlWebComponents.IconLib(store);

// Directive
// Vue.directive('has', has)
// Vue.directive('focus', focus)

// Filters

// router
routerInit(router);

window.axios = axios;
window._ = _;

import App from './App'

Vue.config.productionTip = false;
Vue.prototype._ = _;
Vue.prototype.$axios = axios;

// test async components
import vueModuleLoader from 'vue-module-loader'
Vue.use(vueModuleLoader);

const app = new Vue({
    store,
    router,
    ...App
}).$mount('#app');

/*app.$moduleLoader({
    'jzl-page-design': `/modules/jzl-page-design/jzl-page-design.umd.js`
});*/
//window.router = router
